/**
 * Cookiebot consent helpers for marketing and analytics gating.
 */

export const hasMarketingConsent = () => {
  if (typeof window === "undefined") return false;
  return Boolean(
    window.Cookiebot &&
      window.Cookiebot.consent &&
      window.Cookiebot.consent.marketing
  );
};

/**
 * Analytics / functional-style consent used to gate Braze hero events.
 * If Cookiebot is not loaded, allow tracking.
 */
export const canTrackAnalytics = () => {
  if (typeof window === "undefined") return true;

  if (window.Cookiebot && window.Cookiebot.consent) {
    return Boolean(
      window.Cookiebot.consent.statistics ||
        window.Cookiebot.consent.preferences
    );
  }

  return true;
};

/** Reopen Cookiebot preference center. */
export const openCookiePreferences = () => {
  if (typeof window !== "undefined" && window.Cookiebot) {
    window.Cookiebot.renew();
  }
};
